import * as React from "react";
import useEntityTitles from "hooks/useEntityTitles";
import { Link, Spinner } from "components/common";
import { ListGroup, ListGroupItem } from "components/bootstrap";
import useInputMetrics from "hooks/useInputMetrics";
import Routes from "routing/Routes";
const AssociatedStreamsSection = ({ input }) => {
  var _a;
  const { metricsByInputId, isInitialLoading, isError } = useInputMetrics([input.id], ["messages_per_stream"]);
  const messagesPerStream = (_a = metricsByInputId[input.id]) == null ? void 0 : _a.messages_per_stream;
  const streamIds = messagesPerStream ? Object.keys(messagesPerStream) : [];
  const titleEntities = streamIds.map((id) => ({ id, type: "streams" }));
  const { titlesById, isInitialLoading: areTitlesLoading } = useEntityTitles(titleEntities);
  if (isInitialLoading && !messagesPerStream) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  if (isError) {
    return /* @__PURE__ */ React.createElement("p", null, "Could not load associated streams.");
  }
  if (!messagesPerStream || streamIds.length === 0) {
    return /* @__PURE__ */ React.createElement("p", null, "No streams are associated with this input in the last 24 hours.");
  }
  return /* @__PURE__ */ React.createElement(ListGroup, { componentClass: "ul" }, streamIds.map((streamId) => {
    const title = titlesById[streamId];
    const label = title != null ? title : areTitlesLoading ? streamId : `${streamId} (deleted)`;
    return /* @__PURE__ */ React.createElement(ListGroupItem, { key: streamId }, title ? /* @__PURE__ */ React.createElement(Link, { to: Routes.stream_view(streamId) }, label) : label);
  }));
};
export default AssociatedStreamsSection;
